package modysy.menu

import modysy.InputHandler
import modysy.gamestate.{GameState, GameStateManager}
import modysy.view.Color
import modysy.Level
import org.scalajs.dom

class LevelMenu(
    stateManager: GameStateManager,
    inputs: InputHandler,
    width: Double,
    height: Double,
    numLevels: Int
) extends AbstractMenu(inputs, width, height) {

  private val startx = 0.1 * width
  private val starty = 0.2 * height
  private val menuWidth = 0.8 * width
  private val menuHeight = 0.6 * height
  private val num_rows = 2
  private val num_collumns = 5

  private val buttonHeight = 0.8 * (4.0 / 24) * width
  private val buttonDistance = 0.8 * (1.0 / 24) * width

  {
    def makeButton(nr: Int): RectangleButton = {
      val x = startx + buttonHeight / 2 + ((nr - 1) % num_collumns) * (buttonHeight + buttonDistance)
      val y = starty + buttonHeight / 2 + (((nr - 1) % (num_collumns * num_rows)) / num_collumns) * (buttonHeight + buttonDistance)
      val button = new RectangleButton(
        x,
        y,
        buttonHeight,
        buttonHeight
      )
      button.textDisplayed = nr.toString
      button.colorBackgroundSelected = Color.Yellow
      button.action = () => {
        stateManager.setLevel(nr)
        stateManager.startLevel()
      }
      button
    }

    val levelButtons: List[RectangleButton] =
      (1 to numLevels).map(makeButton).toList
    buttons = levelButtons ::: buttons

    val backButton =
      new TextButton(width * 0.2, height * 0.9, "Main Menu")
    backButton.fontSize = Math.round(height / 16f).toInt
    backButton.action = () => {
      stateManager.backToMainMenu()
    }

    buttons = backButton :: buttons
    buttons.foreach(button => {
      val tmp = button.isEnabled
      button.isEnabled = () => {
        tmp() && (stateManager.gameState == GameState.levelMenu)
      }
    })
    buttons.foreach(button => {
      button.enableTouch(inputs)
    })
  }

  override def render(ctx: dom.CanvasRenderingContext2D): Unit = {

    ctx.fillStyle = Color.Black
    ctx.fillRect(0, 0, width, height)

    ctx.fillStyle = Color.White
    ctx.font = "px Arial"

    ctx.font = height / 12 + "px Arial"
    ctx.fillStyle = Color.White
    ctx.textBaseline = "center"
    ctx.fillText("Select a level", width / 2, 0.1 * height, Integer.MAX_VALUE)
    ctx.textBaseline = "alphabetic"

    super.render(ctx)
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/2d4fb5cd/0/mtv-pr-2018/modysy-product/src/main/scala/modysy/menu/LevelMenu.scala